import { DEFAULT_CONTACT_EMAIL } from "../constants";

export const REVIEWGEN_ACCELERATORS = [
   {
    id: "sn-reviewgen",
    title: "SN-ReviewGen",
    category: "ServiceNow",
    accentKey: "servicenow",
    tagline: "AI-powered code review for ServiceNow development",
    logoUrl: "/assets/accelerators/sn-reviewgen.png",
    downloadUrl: "/downloads/SN-ReviewGen.zip",
    contactEmail: DEFAULT_CONTACT_EMAIL,
    overview: [
      "ReviewGen is an AI powered code review solution designed seamlessly for ServiceNow.",
      "Think of ReviewGen as an automatic quality checker for your code. It removes the need for slow, manual reviews by instantly checking scripts, business rules and script includes for issues before they go live.",
      "This helps teams deliver work faster, reduce errors and rework, lower risk in production, and maintain consistent qualitywithout adding more people or slowing down delivery.",
      "Unlike traditional linters or static rule checkers, ReviewGen understands code intent and context, suggests meaningful improvements (not just syntax fixes), enforces best practices/performance/security standards, and acts as an AI teammate reviewing code instantly and consistently.",
    ],
    benefits: [
      {
        title: "Transform Development Speed (Velocity)",
        points: [
          "Instant Feedback: Eliminate the \"waiting game\" of manual peer reviews. Developers get comprehensive feedback in seconds.",
          "Remove Bottlenecks: Reduce reliance on senior developers for repetitive review work so they can focus on innovation and architecture.",
        ],
      },
      {
        title: "Guarantee High-Performance Code (Quality)",
        points: [
          "Beyond Syntax: Catch logic flaws, security vulnerabilities, and performance bottlenecks that basic tools often miss.",
          "Total Consistency: Enforce unified coding standards across the orgevery script reaches a consistent quality bar.",
        ],
      },
      {
        title: "Future-Proof Your Platform (Stability)",
        points: [
          "Slash Technical Debt: Identify risky \"anti-patterns\" before they reach production to simplify maintenance and upgrades.",
          "Enterprise Security: Scan for vulnerabilities and align scripts with strong security protocols.",
        ],
      },
      {
        title: "Empower Your Developers (Growth)",
        points: [
          "Continuous Learning: Constructive coaching in real time to reinforce best practices.",
          "Reduced Friction: Minimize back-and-forth between developers and reviewers for a more agile workflow.",
        ],
      },
      {
        title: "Measure Your Success (Visibility)",
        points: [
          "ROI Dashboard: Track review activity, severity of issues caught, and estimate hours/cost saved by automation.",
        ],
      },
    ],
  },
  {
    id: "SAP-reviewgen",
    title: "SAP-ReviewGen",
    category: "SAP",
    accentKey: "SAP",
    tagline: "AI-powered code review for SAP development",
    logoUrl: "/assets/accelerators/sn-reviewgen.png",
    downloadUrl: "",
    contactEmail: DEFAULT_CONTACT_EMAIL,
    overview: [
      "This tool extends AI-powered code review to SAP ABAP development through SAP's third-party API integration. It analyzes ABAP source code alongside the results of SAP's existing static code analysis tools, such as ATC and Code Inspector, providing the AI with both the code and its associated findings as contextual input. By leveraging this combined context, the AI delivers a more comprehensive, prioritized, and context-aware code review instead of evaluating the code in isolation.",
      "How it works",
      "1. Submit your source code and existing code analysis ATC results.",
      "2. Analyze both inputs together using SAP-reviewgen.",
      "3. Correlate code with the ATC findings to identify deeper insights and eliminate redundant issues or findings.",
      "4. Prioritize findings based on severity, impact, and context.",
      "5. Receive a single, consolidated report with actionable recommendations.",
    ],
    benefits: [
      {
        title: "Instant feedback, no manual review wait",
        points: [
          "Results appear in seconds, right inside the editor  so issues get caught while the code is still fresh, not days later in a review thread.",
        ],
      },
      {
        title: "Goes beyond fixed rules",
        points: [
          "Every issue is categorized Critical, Medium, or Low, so developers know what to fix first instead of facing a wall of warnings. Rule-based checks catch known patterns, but miss context-dependent issues that depend on how the code is actually used. The AI looks at the full script, not just isolated rules, so it can catch what fixed checks can't.",
        ],
      },
      {
        title: "Fits into existing SAP workflows",
        points: [
          "Built on SAP's third-party API integration, so it slots into your current ABAP development process rather than requiring a new standalone tool or separate review step.",
        ],
      },
      {
        title: "Bring your own LLM",
        points: [
          "Clients can plug in their own LLM instead of the default one  experience, without changing how the integration or review workflow function.",
        ],
      },
    ],
  },  
  {
    id: "Oracle-reviewgen",
    title: "Oracle-ReviewGen",
    category: "Oracle",
    accentKey: "oracle",
    tagline: "AI-powered code review for Oracle Database development",
    logoUrl: "/assets/accelerators/sn-reviewgen.png",
    downloadUrl: "",
    contactEmail: DEFAULT_CONTACT_EMAIL,
    overview: [
      "ReviewGen is an AI-powered code review plugin for Oracle SQL Developer that integrates directly into the SQL Developer toolbar. It reviews your PL/SQL code to identify risky patterns, performance bottlenecks, and coding best-practice violations before they reach production. Beyond detecting code quality concerns, ReviewGen provides contextual explanations of their potential impact, enabling developers to understand the reasoning behind each finding and make informed improvements.",
      "How it works",
      "1. Open any PL/SQL script in the SQL Developer editor.",
      "2. Click the ReviewGen icon in the toolbar.",
      "3. The script is submitted for code review and analysis.",
      "4. Get  instant review  Line, Severity, and a review Comment for each code segment.",
    ],
    benefits: [
      {
        title: "Instant feedback, no manual review wait",
        points: [
          "Results appear in seconds, right inside the editor  so issues get caught while the code is still fresh, not days later in a review thread.",
        ],
      },
      {
        title: "Prioritized, not just flagged",
        points: [
          "Every issue is categorized Critical, Medium, or Low, so developers know what to fix first instead of facing a wall of warnings.",
        ],
      },
      {
        title: "Catches what's easy for humans to miss",
        points: [
          "SQL injection risk, unclosed cursors, row-by-row processing, unvalidated inputs  the kind of issues that cause production incidents but slip through a quick read-through.",
        ],
      },
      {
        title: "Zero workflow disruption",
        points: [
          " No separate tool, no copying code elsewhere. Review happens inside SQL Developer as part of writing the code, not a separate step.",
        ],
      },
      {
        title: "Bring your own LLM",
        points: [
          "Clients can plug in their own LLM instead of the default one  same toolbar experience, different engine underneath.",
        ],
      },
    ],
  },
];
